import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../lib/api";
import { StatusBadge } from "../../components/StatusBadge";

export default function MyLeave() {
  const [balances, setBalances] = useState([]);
  const [history, setHistory] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ leave_type: "CL", from_date: "", to_date: "", reason: "" });

  const load = useCallback(() => {
    api.get("/leave/balance/me").then((r) => setBalances(r.data));
    api.get("/leave/requests/me").then((r) => setHistory(r.data));
  }, []);
  useEffect(() => { load(); api.get("/holidays").then((r) => setHolidays(r.data)); }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/leave/requests", form);
      toast.success("Leave request submitted");
      setShow(false); setForm({ leave_type: "CL", from_date: "", to_date: "", reason: "" });
      load();
    } catch (err) { toast.error(errText(err)); }
  };

  return (
    <div className="space-y-5" data-testid="my-leave-page">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-2xl font-extrabold">My leave</h1>
        <button onClick={() => setShow(!show)} data-testid="apply-leave-toggle"
          className="tap-scale px-5 py-2.5 rounded-full bg-primary text-white text-sm font-bold hover:bg-[#A63F07] transition-colors duration-200">{show ? "Close" : "Apply leave"}</button>
      </div>

      <div className="grid grid-cols-3 gap-3">
        {balances.map((b) => (
          <div key={b.leave_type} className="bg-white border border-stone-200 rounded-2xl p-4 text-center">
            <div className="font-heading text-2xl font-extrabold tabular-nums">{b.balance}</div>
            <div className="text-[11px] text-stone-500 font-semibold">{b.name}</div>
          </div>
        ))}
      </div>

      {show && (
        <form onSubmit={submit} className="bg-white border border-stone-200 rounded-2xl p-5 space-y-3">
          <select value={form.leave_type} onChange={(e) => setForm({ ...form, leave_type: e.target.value })} data-testid="leave-type-select"
            className="w-full min-h-[48px] px-3 rounded-lg border border-stone-300 bg-white">
            {balances.map((b) => <option key={b.leave_type} value={b.leave_type}>{`${b.name} (${b.balance} left)`}</option>)}
          </select>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-semibold text-stone-500">From</label>
              <input type="date" required value={form.from_date} onChange={(e) => setForm({ ...form, from_date: e.target.value })} data-testid="leave-from-input" className="w-full min-h-[48px] px-3 rounded-lg border border-stone-300" />
            </div>
            <div>
              <label className="text-xs font-semibold text-stone-500">To</label>
              <input type="date" required value={form.to_date} onChange={(e) => setForm({ ...form, to_date: e.target.value })} data-testid="leave-to-input" className="w-full min-h-[48px] px-3 rounded-lg border border-stone-300" />
            </div>
          </div>
          <input placeholder="Reason" required value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} data-testid="leave-reason-input" className="w-full min-h-[48px] px-3 rounded-lg border border-stone-300" />
          <button type="submit" data-testid="submit-leave-button" className="tap-scale w-full min-h-[48px] rounded-full bg-primary text-white font-bold hover:bg-[#A63F07] transition-colors duration-200">Submit request</button>
        </form>
      )}

      <div className="bg-white border border-stone-200 rounded-2xl divide-y divide-stone-100">
        <div className="p-4 font-heading font-bold text-sm">Leave history</div>
        {history.length === 0 && <p className="p-6 text-center text-sm text-stone-400">No leave requests yet.</p>}
        {history.map((r) => (
          <div key={r.id} className="p-4 flex items-center justify-between" data-testid={`my-leave-${r.id}`}>
            <div>
              <div className="font-semibold text-sm">{r.leave_type} · {r.days} day{r.days > 1 ? "s" : ""}</div>
              <div className="text-xs text-stone-500 tabular-nums">{r.from_date} → {r.to_date}</div>
            </div>
            <StatusBadge status={r.status} />
          </div>
        ))}
      </div>

      <div className="bg-white border border-stone-200 rounded-2xl p-5">
        <h3 className="font-heading font-bold text-sm mb-3">Holiday calendar</h3>
        <div className="space-y-2">
          {holidays.map((h) => (
            <div key={h.id} className="flex justify-between text-sm">
              <span className="font-semibold">{h.name}</span><span className="text-stone-500 tabular-nums">{h.date}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
